export const fetchBankHolidays = async (): Promise<Date[]> => {
  try {
    const response = await fetch('https://www.gov.uk/bank-holidays.json');
    if (!response.ok) throw new Error('Failed to fetch bank holidays');

    const data = await response.json();

    // Extract holidays for England and Wales
    const holidays = data['england-and-wales'].events.map(
      (event: any) => new Date(event.date)
    );

    return holidays;
  } catch (error) {
    console.error('Error fetching bank holidays:', error);
    return [];
  }
};
